import { createReducer, on } from '@ngrx/store';
import { StovesActions } from './stoves.actions';
import { BatteryStatus } from '../../shared/models/BatteryStatus';
import { StoveData } from '../../shared/models/StoveData';

export interface StovesState {
  stovesByUserId: Record<number, string[]>;
  fullInfoStoves: StoveData[];
}

export const initialStovesState: StovesState = {
  stovesByUserId: {
    1: [],
    2: [],
    3: ['305786'],
    4: ['30568', '78695', '76586', '56786', '35676', '35677', '35678', '35679', '35680', '35681'],
  },
  fullInfoStoves: [
    {
      model: 'Aduro 22',
      serial: '007567',
      temperature: '305°C',
      operatingTime: '125 Hours',
      battery: BatteryStatus.LOW,
      updatedDate: new Date('2025-10-27T16:37:00'),
      id: '0',
    },
    {
      model: 'Aduro 07',
      serial: '007563',
      temperature: '111°C',
      operatingTime: '3 Hours',
      battery: BatteryStatus.HIGH,
      updatedDate: new Date('2025-09-27T11:15:00'),
      id: '1',
    },
    {
      model: 'Aduro 15',
      serial: '007588',
      temperature: '215°C',
      operatingTime: '56 Hours',
      battery: BatteryStatus.HIGH,
      updatedDate: new Date('2025-10-28T09:30:00'),
      id: '2',
    },
    {
      model: 'Aduro 09',
      serial: '007591',
      temperature: '45°C',
      operatingTime: '400 Hours',
      battery: BatteryStatus.LOW,
      updatedDate: new Date('2025-10-29T10:00:00'),
      id: '3',
    },
  ],
};

export const stovesReducer = createReducer(
  initialStovesState,

  on(StovesActions.loadInitial, (state, { stovesByUserId }) => ({
    ...state,
    stovesByUserId,
  })),

  on(StovesActions.addStove, (state, { userId, stoveId }) => ({
    ...state,
    stovesByUserId: {
      ...state.stovesByUserId,
      [userId]: [...(state.stovesByUserId[userId] || []), stoveId],
    },
  })),

  on(StovesActions.removeStove, (state, { userId, stoveId }) => ({
    ...state,
    stovesByUserId: {
      ...state.stovesByUserId,
      [userId]: (state.stovesByUserId[userId] || []).filter((id) => id !== stoveId),
    },
  })),

  on(StovesActions.loadFullInfoStoves, (state, { fullInfoStoves }) => ({
    ...state,
    fullInfoStoves,
  })),

  on(StovesActions.addFullInfoStove, (state, { stove }) => ({
    ...state,
    fullInfoStoves: [...state.fullInfoStoves, stove],
  })),
);
